import * as DialogPrimitive from '@radix-ui/react-dialog';

type ModalYoutubeEmbedProps = {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
};

export function ModalYoutubeEmbed(props: ModalYoutubeEmbedProps) {
  const { isOpen, onClose, videoUrl } = props;

  const separator = videoUrl.includes('?') ? '&' : '?';
  const cleanUrl = `${videoUrl}${separator}rel=0&modestbranding=1`;

  return (
    <DialogPrimitive.Root
      open={isOpen}
      onOpenChange={function (open) {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-[60] bg-black/70" />
        <DialogPrimitive.Content
          aria-describedby={undefined}
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed left-1/2 top-1/2 z-[60] w-[70%] -translate-x-1/2 -translate-y-1/2 overflow-hidden outline-none"
        >
          <div className="relative">
            <div className="aspect-video w-full">
              <iframe
                src={cleanUrl}
                className="h-full w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
